export default __webpack_public_path__ + "static/media/AdBugs_01.0230526a.png";